import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'Service/api/api';

export const getLoadList = createAsyncThunk(
  `load/getLoadList`,
  async ({
    page,
    pageSize,
    category,
  }: {
    page?: number;
    pageSize?: number;
    category?: string;
  }) => {
    try {
      const response = await api.load.getLoadList({
        page,
        pageSize,
        category,
      });

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);

export const getLoad = createAsyncThunk(`load/getLoad`, async (id: number) => {
  try {
    const response = await api.load.getLoad(id);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const setNextLoadStatus = createAsyncThunk(
  `load/updateStatusToNext`,
  async (data: { order_id: number }) => {
    try {
      const result = await api.load.setNextLoadStatus(data);
      return result.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);

export const setPrevLoadStatus = createAsyncThunk(
  `load/setPrevLoadStatus`,
  async (data: { order_id: number }) => {
    try {
      const result = await api.load.setPrevLoadStatus(data);
      return result.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);
